import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as sessionActions from './session.actions';
import * as clientActions from '../clients/client-details/store/client.actions';
import * as casesActions from '../clients/client-details/cases/store/cases.actions';
import * as notificationsActions from '../notifications/store/notifications.actions';

import { switchMap, map } from 'rxjs/operators';
import { ClientsSelectors, ScookieService, UsersService } from '@store';
import { of } from 'rxjs';
import { NavigationService } from '../core/navigation.service';

@Injectable()
export class SessionEffects {

    loadMenu$ = createEffect(() => this.actions$.pipe(
        ofType(sessionActions.LOAD_MENU),
        switchMap(() => {
            return this.nav.getBaseMenu().pipe(map(response => new sessionActions.LoadMenuSuccess(response)));
        })
    ));

    loadUsers$ = createEffect(() => this.actions$.pipe(
        ofType(sessionActions.LOAD_USERS),
        switchMap(() => {
            return this.users.getUsers().pipe(map(response => new sessionActions.LoadUsersSuccess(response)));
        })
    ));

    loadMenuSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(sessionActions.LOAD_MENU_SUCCESS),
        map(() => new notificationsActions.LoadNotifications())
    ));

    loadRecentClients$ = createEffect(() => this.actions$.pipe(
        ofType(sessionActions.LOAD_RECENT_CLIENTS),
        switchMap(() => this.scookieService.getRecentClients().pipe(
            map(clients => new sessionActions.LoadRecentClientsSuccess(clients))
        ))
    ));

    loadRecentClientsSuccessData$ = createEffect(() => this.actions$.pipe(
        ofType(sessionActions.LOAD_RECENT_CLIENTS_SUCCESS),
        switchMap(() => of(
            clientActions.loadClientData(),
            casesActions.loadCases(),
            casesActions.loadRegnskabsaar()
        ))
    ));

    selectClient$ = createEffect(() => this.actions$.pipe(
        ofType<sessionActions.SelectClient>(sessionActions.SELECT_CLIENT),
        map(action => action.payload),
        switchMap((kid) => this.clientsSelector.clientByKid$(kid).pipe(
            switchMap(client => {
                if (!client) { return of(new sessionActions.LoadRecentClients()); }
                return this.scookieService.saveCookie('sidstekunde', client.glkundenr.toString()).pipe(
                    map(() => new sessionActions.LoadRecentClients())
                );
            })
        ))
    ));

    constructor(
        private actions$: Actions,
        private nav: NavigationService,
        private users: UsersService,
        private scookieService: ScookieService,
        private clientsSelector: ClientsSelectors
    ) {}
}
